/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

import { rescheduleAppointment } from 'actions/BookingActions';
import cx from 'classnames';
import { trackEvent } from 'integrations/metrics';
import { EventNames } from 'integrations/metrics/events';
import { EventAction, EventObjectType } from 'integrations/metrics/types';
import moment from 'moment-timezone';
import { compose } from 'redux';
import { getSelectedServices } from 'selectors/services';

import JoinWaitlistButton from 'routes/waitlist/JoinButton/JoinButton';

import { updateAppointment } from '../../../actions';
import Button from '../../../components/Button';
import AppointmentInfo from '../AppointmentInfo';

import s from './SelectTime.module.css';

class SelectTime extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showingError: false,
    };

    this.onClickNext = this.onClickNext.bind(this);
    this.goToNextStep = this.goToNextStep.bind(this);
  }

  state = {
    limit: 5,
  };

  loadMore = () => {
    this.setState({ limit: Number.MAX_SAFE_INTEGER });
  };

  onClickNext(event) {
    event.preventDefault();

    if (!this.props.time) {
      if (!this.state.showingError) {
        this.setState({ showingError: true });
        setTimeout(() => {
          this.setState({ showingError: false });
        }, 500);
      }
      return false;
    }

    this.goToNextStep();
  }

  goToNextStep() {
    trackEvent(EventNames.NEXT_BUTTON_CLICKED_DATE_TIME, {
      action: EventAction.SELECT,
      productSection: 'Booking',
      objectType: EventObjectType.BUTTON,
      reschedule: this.props.isReschedule,
      bundle_size: 1,
      is_msmp_booking: false,
      page_identifier: 'time',
      service_ids: this.props.selectedServices,
    });

    if (this.props.appointment.appointmentGuid && this.props.isReschedule) {
      return this.props.onRescheduleAppointment((params) =>
        this.props.navigateToNextStep(params),
      );
    } else if (
      this.props.publicUser.preferences.fixed_location_preference &&
      !this.props.publicUser.preferences.housecall_location_preference
    ) {
      this.props.navigateToNextStep({ stepKey: 'personal-info' });
    } else {
      this.props.navigateToNextStep({ stepKey: 'select-location' });
    }
  }

  navigationPrefix() {
    if (this.props.isUserPublicPage) {
      return `/p/${this.props.slug}`;
    }
    return '';
  }

  render() {
    const { time, appointment, isWaitlistEnabled } = this.props;

    const getTimeSlots = (selectedTime) => {
      let selectedTimes = appointment.timeSlots;

      if (selectedTime) {
        selectedTimes = selectedTimes.map((time) => {
          if (
            time &&
            moment(time.start).toLocaleString() ==
              moment(selectedTime).toLocaleString()
          ) {
            time.selected = true;
          } else {
            time.selected = false;
          }
          return time;
        });
      }

      return selectedTimes || null;
    };

    const timeSlots = getTimeSlots(time); // getFakeTimeSlots(time)

    const formatTimeItemText = (item) =>
      `${moment(item.start).format('h:mm A')} - ${moment(item.end).format(
        'h:mm A',
      )}`;

    const renderTimes = timeSlots.map((timeItem) => (
      <label
        key={timeItem.start}
        className={cx(s.time, timeItem.selected ? s.selectedTime : '')}
      >
        <input
          checked={timeItem.selected}
          className="hidden"
          name="time"
          onChange={() => {
            this.props.updateTime(timeItem.start);
          }}
          type="radio"
          value={formatTimeItemText(timeItem)}
        />
        {formatTimeItemText(timeItem)}
      </label>
    ));

    const renderScrollCue = () => {
      if (timeSlots.length > 5) {
        return (
          <div className={s.scrollCue}>Scroll down for more availabilities</div>
        );
      }
    };

    return (
      <form className={s.selectTimeForm} onSubmit={this.onClickNext}>
        <div className={cx(s.root, this.state.showingError ? 'error' : '')}>
          <div className={s.list}>{renderTimes}</div>
        </div>
        {renderScrollCue()}
        <Button className={s.button} type="submit">
          Next
        </Button>
        {isWaitlistEnabled && <JoinWaitlistButton />}
        <AppointmentInfo />
      </form>
    );
  }
}

export default compose(
  withRouter,
  connect(
    (state, ownProps) => {
      const isReschedule = ownProps.router.query.action === 'reschedule';

      return {
        selectedProfessional: state.selectedProfessional,
        selectedServices: getSelectedServices(state),
        time: state.appointment?.time,
        timeSlots: state.appointment?.timeSlots,
        appointment: state.appointment,
        publicUser: state.publicUser,
        isMultiUser: state.publicUser.multi_user,
        isWaitlistEnabled:
          state.publicUser.preferences.waitlist_registration_enabled &&
          !isReschedule,
        professional: state.appointment?.professional,
        isReschedule,
      };
    },
    (dispatch) => ({
      updateTime(time) {
        dispatch(updateAppointment('time', time));
      },
      onRescheduleAppointment(navigateToNextStep) {
        dispatch(rescheduleAppointment(navigateToNextStep));
      },
    }),
  ),
)(SelectTime);
